import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import {
  getAllMarketsByEvent,
  getBookmakerMarketsByEvent,
  addExchangeBet,
  getCurrencyTypeFromToken,
  addToMultiMarket,
  removeToMultiMarket,
  checkIncludeMultiMarket,
} from '../../store';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
} from '@material-ui/core';
import { IonIcon } from '@ionic/react';
import moment from 'moment';
import InfoImg from '../../assets/images/sportsbook/info.svg';
import {
  BookmakerDTO,
  BookmakerRunnerDTO,
} from '../../models/common/BookmakerDTO';
import { EventDTO } from '../../models/common/EventDTO';
import API from '../../api';
import { PlaceBetRequest } from '../../models/BsData';
import ExchOddBtn from '../ExchOddButton/ExchOddButton';
import { UserBet } from '../../models/UserBet';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import Modal from '../../components/Modal/Modal';
import Betslip from '../../components/ExchBetslip/ExchBetslip';
import MarketTermsCondi from '../../components/MarketTermsCondi/MarketTermsCondi';
import { TOSS_ODD_VALUE } from '../../constants/CommonConstants';
import './ExchBookmakerMarketTable.scss';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useMarketLocalState } from '../../hooks/storageHook';
import multipin from '../../assets/images/common/multipin.svg';
import removemultipin from '../../assets/images/common/removemultimarket.svg';
import { useHistory } from 'react-router-dom';

type StoreProps = {
  eventData: EventDTO;
  bmMData: BookmakerDTO[];
  bets: PlaceBetRequest[];
  openBets: UserBet[];
  addExchangeBet: (data: PlaceBetRequest) => void;
  loggedIn: boolean;
  enableBookmaker: boolean;
  getFormattedMinLimit: (num: number) => string;
  getFormattedMaxLimit: (num: number) => string;
  isMultiMarket?: boolean;
  exposureMap: any;
};

type OddsInfoMsg = {
  launch: boolean;
  oddsType: string;
  eventTypeID: string;
};

const BmMTable: React.FC<StoreProps> = (props) => {
  const {
    eventData,
    bmMData,
    bets,
    openBets,
    addExchangeBet,
    enableBookmaker,
    loggedIn,
    isMultiMarket,
    exposureMap,
  } = props;

  const [bmLimits, setBMLimits] = useState<any>({});
  const [bmDataState, setBmDataState] = useState<BookmakerDTO[]>([]);
  const [infoDilalog, setInfoDialog] = useState<OddsInfoMsg>({
    launch: false,
    oddsType: null,
    eventTypeID: null,
  });
  const [multiMarketData, setMultiMarketData] = useMarketLocalState();
  let history = useHistory();
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  const tableFields = [
    {
      key: 'teamName',
      Label: 'Market',
      className: 'market-name-cell-head',
      align: 'left',
    },
    {
      key: 'Back',
      Label: 'Back',
      className: 'odds-cell-head',
      align: 'center',
    },
    {
      key: 'Lay',
      Label: 'Lay',
      className: 'odds-cell-head',
      align: 'center',
    },
  ];

  const getOpenBetsPL = (
    runner: BookmakerRunnerDTO,
    marketId: string,
    marketName: string
  ) => {
    if (exposureMap && exposureMap?.[`${marketId}:${marketName}`]) {
      for (let rn of exposureMap[`${marketId}:${marketName}`]) {
        if (rn.runnerId === runner.runnerId) {
          return rn?.userRisk / cFactor;
        }
      }
    }
  };

  useEffect(() => {
    let localBMData = [];
    bmMData &&
      bmMData.forEach((indvBM) => {
        if (!indvBM.disable) {
          localBMData.push(indvBM);
        }
      });
    setBmDataState(localBMData);
  }, [bmMData]);

  const getOpenBetsPLInArray = (
    runner: BookmakerRunnerDTO,
    marketId: string,
    marketName: string
  ) => {
    let pl = getOpenBetsPL(runner, marketId, marketName);
    return pl ? [pl] : [];
  };

  const getTotalPL = (
    runner: BookmakerRunnerDTO,
    marketId: string,
    marketName: string
  ) => {
    let returns = null;
    const mBetslipBets = bets.filter(
      (b) => b.marketName === 'Bookmaker' && b.amount && b.amount > 0
    );
    if (mBetslipBets.length > 0) {
      returns = getOpenBetsPL(runner, marketId, marketName);
      for (let bet of mBetslipBets) {
        const plVal = (bet.oddValue / 100 + 1) * bet.amount - bet.amount;
        if (bet.betType === 'BACK') {
          if (bet.outcomeId === runner.runnerId)
            returns ? (returns += plVal) : (returns = plVal);
          else returns ? (returns -= bet.amount) : (returns = 0 - bet.amount);
        } else if (bet.betType === 'LAY') {
          if (bet.outcomeId === runner.runnerId)
            returns ? (returns -= plVal) : (returns = 0 - plVal);
          else returns ? (returns += bet.amount) : (returns = bet.amount);
        }
      }
    }
    return [returns];
  };

  // const fetchBetLimits = async (marketId: string) => {
  //   try {
  //     const payload = {
  //       sportId: eventData.sportId,
  //       competitionId: eventData.competitionId,
  //       eventId: eventData.eventId,
  //       marketType: 'BOOKMAKER',
  //       marketId: marketId,
  //       outcomeDesc: 'fancy',
  //       sessionId: marketId,
  //       mcategory: 'ALL',
  //     };
  //     let response;
  //     if (sessionStorage.getItem('jwt_token')) {
  //       response = await API.post('/bs/fetch-market-limits', payload, {
  //         headers: {
  //           Authorization: sessionStorage.getItem('jwt_token'),
  //         },
  //       });
  //     } else {
  //       response = await API.post('/bs/fetch-market-limits', payload);
  //     }
  //     if (response.status === 200 && response.data.success) {
  //       let limits = bmLimits;
  //       limits[marketId ? marketId : eventData.marketId] = {
  //         min: response.data.limits.minStake,
  //         max: response.data.limits.maxStake,
  //         oddLimt: response.data.limits.maxOdd,
  //       };
  //       setBMLimits({ ...limits });
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  useEffect(() => {
    const elm = document.getElementById('mob-betslip');
    if (elm)
      elm?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
  }, [bets]);
  const handleMultiMarket = (
    competitionId,
    eventId,
    marketId,
    providerName,
    sportId,
    isAdd = true
  ) => {
    if (loggedIn) {
      if (isAdd) {
        addToMultiMarket(
          competitionId,
          eventId,
          marketId,
          providerName,
          sportId
        );
        marketId &&
          setMultiMarketData((prevState) => {
            return [
              ...prevState,
              {
                competitionId,
                eventId,
                marketId,
                providerName,
                sportId,
              },
            ];
          });
      } else {
        removeToMultiMarket(eventId, marketId);
        marketId &&
          setMultiMarketData((prevState) => {
            let data = [...prevState];
            const index = data?.findIndex(
              (itm) => itm.eventId === eventId && itm.marketId === marketId
            );
            index > -1 && data.splice(index, 1);
            return [...data];
          });
      }
    } else {
      history.push('/login');
    }
  };
  return (
    <>
      {bmDataState.map((market, index) => (
        <>
          {!isMultiMarket ||
          checkIncludeMultiMarket(
            multiMarketData,
            market.marketId,
            eventData.eventId
          ) ? (
            <div className="bm-table-ctn">
              <div className="bm-table-content table-ctn">
                <Accordion defaultExpanded={true}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon className="expand-icon" />}
                    aria-controls="panel1a-content"
                  >
                    <div className="heading-title">
                      <span className="market-name">
                        {!checkIncludeMultiMarket(
                          multiMarketData,
                          market.marketId,
                          eventData?.eventId
                        ) ? (
                          <Tooltip
                            title="Add To Multi Markets "
                            placement="left-start"
                          >
                            <img
                              src={multipin}
                              alt="multipin"
                              className="multi-add-icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                multiMarketData?.length < 10 &&
                                  handleMultiMarket(
                                    eventData?.competitionId,
                                    eventData?.eventId,
                                    market.marketId,
                                    eventData?.providerName,
                                    eventData?.sportId,
                                    true
                                  );
                              }}
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip
                            title="Remove From Multi Markets"
                            placement="left-start"
                          >
                            <img
                              src={removemultipin}
                              alt="multipin"
                              className="multi-remove-icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleMultiMarket(
                                  eventData?.competitionId,
                                  eventData?.eventId,
                                  market.marketId,
                                  eventData?.providerName,
                                  eventData?.sportId,
                                  false
                                );
                              }}
                            />
                          </Tooltip>
                        )}{' '}
                        {market.marketName}{' '}
                        <span className="event-name">
                          {isMultiMarket ? eventData?.eventName : null}
                        </span>
                      </span>

                      <span className="bet-limits-section">
                        MIN:{' '}
                        {market?.marketLimits?.minStake
                          ? market?.marketLimits.minStake / cFactor
                          : 100}{' '}
                        MAX :{' '}
                        {market?.marketLimits?.maxStake
                          ? Number(market?.marketLimits?.maxStake / cFactor) <
                            1000
                            ? Number(market?.marketLimits?.maxStake / cFactor)
                            : (
                                market?.marketLimits?.maxStake /
                                cFactor /
                                1000
                              ).toFixed(0) + 'K'
                          : 5000}
                      </span>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails className="inplay-events-tbl-container">
                    <TableContainer component={Paper}>
                      <Table className="bm-table">
                        <TableBody>
                          <TableRow className="header-row">
                            {tableFields.map((tF, index) => (
                              <TableCell
                                key={tF.key + index}
                                align={tF.align === 'left' ? 'left' : 'center'}
                                className={tF.className}
                              >
                                {tF.key === 'lay' || 'back' ? (
                                  <div
                                    className={tF.key.toLowerCase() + '-odd'}
                                  >
                                    {tF.Label}
                                  </div>
                                ) : (
                                  tF.Label
                                )}
                              </TableCell>
                            ))}
                          </TableRow>
                          {market.runners.map((bmSelection, index) => (
                            <>
                              <TableRow>
                                <TableCell className="team-name-cell">
                                  <div className="team">
                                    {bmSelection.runnerName}
                                    {getOpenBetsPLInArray(
                                      bmSelection,
                                      market.marketId,
                                      market.marketName
                                    ).map((ret) =>
                                      ret !== null ? (
                                        <span
                                          className={
                                            ret >= 0 ? 'profit' : 'loss'
                                          }
                                        >
                                          {ret > 0
                                            ? '+' + Number(ret).toFixed(2)
                                            : Number(ret).toFixed(2)}
                                        </span>
                                      ) : null
                                    )}
                                  </div>
                                  {bets.length > 0 && bets[0].amount > 0 ? (
                                    <div>
                                      {getTotalPL(
                                        bmSelection,
                                        market.marketId,
                                        market.marketName
                                      ).map((ret) =>
                                        ret !== null ? (
                                          <span
                                            className={
                                              ret >= 0 ? 'profit' : 'loss'
                                            }
                                          >
                                            {ret > 0
                                              ? '+' + Number(ret).toFixed(2)
                                              : Number(ret).toFixed(2)}
                                          </span>
                                        ) : null
                                      )}
                                    </div>
                                  ) : null}
                                </TableCell>

                                <TableCell className="odds-cell">
                                  <div className="odds-block">
                                    <ExchOddBtn
                                      mainValue={
                                        bmSelection?.status === 'SUSPENDED' ||
                                        market.suspend ||
                                        market.disable
                                          ? 0
                                          : bmSelection.backPrice
                                      }
                                      subValue={Number(bmSelection.backSize)}
                                      oddType="back-odd"
                                      valueType="bookmakerOdds"
                                      page="inner"
                                      showSubValueinKformat={true}
                                      disable={
                                        (market.status?.toLowerCase() !==
                                          'open' &&
                                          market.status?.toLowerCase() !==
                                            'active') ||
                                        (bmSelection?.status?.toLowerCase() !==
                                          'open' &&
                                          bmSelection?.status?.toLowerCase() !==
                                            'active') ||
                                        !enableBookmaker ||
                                        moment(eventData.openDate).diff(
                                          moment(),
                                          'minutes'
                                        ) >
                                          60 * 24 * 2 ||
                                        market.suspend ||
                                        market.disable
                                      }
                                      onClick={() => {
                                        if (
                                          (market.status?.toLowerCase() !==
                                            'open' &&
                                            market.status?.toLowerCase() !==
                                              'active') ||
                                          (bmSelection?.status?.toLowerCase() !==
                                            'open' &&
                                            bmSelection?.status?.toLowerCase() !==
                                              'active') ||
                                          market.suspend ||
                                          market.disable
                                        ) {
                                          return;
                                        }
                                        const betData: PlaceBetRequest = {
                                          sportId: eventData.sportId,
                                          seriesId: eventData.competitionId,
                                          seriesName: eventData.competitionName,
                                          eventId: eventData.eventId,
                                          eventName: eventData.eventName,
                                          eventDate: eventData.openDate,
                                          marketId: market.marketId,
                                          marketName: market.marketName,
                                          marketType: 'BM',
                                          outcomeId: bmSelection.runnerId,
                                          outcomeDesc: bmSelection.runnerName,
                                          betType: 'BACK',
                                          amount: 0,
                                          oddValue: Number(
                                            bmSelection.backPrice
                                          ),
                                          sessionPrice: -1,
                                          oddLimt:
                                            market?.marketLimits?.maxOdd.toString(),
                                          mcategory: 'ALL',
                                        };
                                        if (
                                          market.marketName.toUpperCase() ===
                                            'TOSS' &&
                                          Number(bmSelection.backPrice) > 0
                                        ) {
                                          betData['displayOddValue'] =
                                            TOSS_ODD_VALUE;
                                        }
                                        addExchangeBet(betData);
                                      }}
                                    />
                                  </div>
                                </TableCell>
                                <TableCell className="odds-cell">
                                  <div className="odds-block">
                                    <ExchOddBtn
                                      mainValue={
                                        bmSelection?.status === 'SUSPENDED' ||
                                        market.suspend ||
                                        market.disable
                                          ? 0
                                          : bmSelection.layPrice
                                      }
                                      subValue={Number(bmSelection.laySize)}
                                      oddType="lay-odd"
                                      valueType="bookmakerOdds"
                                      page="inner"
                                      showSubValueinKformat={true}
                                      disable={
                                        (market.status?.toLowerCase() !==
                                          'open' &&
                                          market.status?.toLowerCase() !==
                                            'active') ||
                                        (bmSelection?.status?.toLowerCase() !==
                                          'open' &&
                                          bmSelection?.status?.toLowerCase() !==
                                            'active') ||
                                        !enableBookmaker ||
                                        moment(eventData.openDate).diff(
                                          moment(),
                                          'minutes'
                                        ) >
                                          60 * 24 * 2 ||
                                        market.suspend ||
                                        market.disable
                                      }
                                      onClick={() => {
                                        if (
                                          (market.status?.toLowerCase() !==
                                            'open' &&
                                            market.status?.toLowerCase() !==
                                              'active') ||
                                          (bmSelection?.status?.toLowerCase() !==
                                            'open' &&
                                            bmSelection?.status?.toLowerCase() !==
                                              'active') ||
                                          market.suspend ||
                                          market.disable
                                        ) {
                                          return;
                                        }
                                        const betData: PlaceBetRequest = {
                                          sportId: eventData.sportId,
                                          seriesId: eventData.competitionId,
                                          seriesName: eventData.competitionName,
                                          eventId: eventData.eventId,
                                          eventName: eventData.eventName,
                                          eventDate: eventData.openDate,
                                          marketId: market.marketId,
                                          marketName: market.marketName,
                                          marketType: 'BM',
                                          outcomeId: bmSelection.runnerId,
                                          outcomeDesc: bmSelection.runnerName,
                                          betType: 'LAY',
                                          amount: 0,
                                          oddValue: Number(
                                            bmSelection.layPrice
                                          ),
                                          sessionPrice: -1,
                                          oddLimt:
                                            market?.marketLimits?.maxOdd.toString(),
                                          mcategory: 'ALL',
                                        };
                                        if (
                                          market.marketName.toUpperCase() ===
                                            'TOSS' &&
                                          Number(bmSelection.layPrice) > 0
                                        ) {
                                          betData['displayOddValue'] =
                                            TOSS_ODD_VALUE;
                                        }
                                        addExchangeBet(betData);
                                      }}
                                    />
                                  </div>
                                </TableCell>
                                {(market.status?.toLowerCase() !== 'open' &&
                                  market.status?.toLowerCase() !== 'active') ||
                                (bmSelection?.status?.toLowerCase() !==
                                  'open' &&
                                  bmSelection?.status?.toLowerCase() !==
                                    'active') ? (
                                  <div
                                    className="disabled-odds-cell"
                                    key={'row-' + index + 'cell-4'}
                                  >
                                    <div className="msg">
                                      {market?.status === 'BALL_RUNNING'
                                        ? 'BALL RUNNING'
                                        : bmSelection?.status === 'BALL_RUNNING'
                                        ? 'BALL RUNNING'
                                        : 'SUSPENDED'}
                                    </div>
                                  </div>
                                ) : null}
                              </TableRow>
                              {bets?.[0]?.marketName === market?.marketName &&
                              bets?.[0]?.outcomeId === bmSelection.runnerId ? (
                                <TableRow className="mob-view" id="mob-betslip">
                                  <TableCell
                                    colSpan={3}
                                    className="betslip-cell"
                                  >
                                    <Betslip mobileView={true} />{' '}
                                  </TableCell>
                                </TableRow>
                              ) : null}
                            </>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Accordion>
                <Modal
                  open={infoDilalog.launch}
                  closeHandler={() =>
                    setInfoDialog({
                      launch: false,
                      oddsType: null,
                      eventTypeID: null,
                    })
                  }
                  customClass="light-bg-title"
                  title="Rules"
                  size="md"
                >
                  <MarketTermsCondi
                    oddsType={infoDilalog.oddsType}
                    eventTypeID={infoDilalog.eventTypeID}
                  />
                </Modal>
              </div>
            </div>
          ) : null}
        </>
      ))}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  const eventType = state.exchangeSports.selectedEventType;
  const competition = state.exchangeSports.selectedCompetition;
  const event = state.exchangeSports.selectedEvent;

  return {
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: PlaceBetRequest) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BmMTable);
